module.exports = __webpack_public_path__ + "img/bp_title_leixing.f1381523.png";